import { sanitize } from '@utils/sanitize'
import { DerivedTimespan } from '../../types/derived_items'

interface DefaultTimespanContentProps {
  timespan: DerivedTimespan
}

const DefaultTimespanContent = ({ timespan }: DefaultTimespanContentProps) => {
  return (
    <div className="content-holder">
      <div className="content-body">
        <span className="title ellipsify-text" dangerouslySetInnerHTML={{ __html: sanitize(timespan.title) }}></span>
      </div>
    </div>
  )
}

export default DefaultTimespanContent
